<div class="modal inmodal fade in create-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal(form)">
                        <span>×</span>
                        <span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title">
                        Unit {{directoryService.moveOutFormResident.suiteNumber}} - Resident Move Out
                    </h4>
                </div>
                <div class="modal-body">
                    <div *ngIf="!(!residentsList.length && !vehiclesList.length && !petsList.length)">
                        <div class="row m-b-sm" *ngIf="!moveInTo">
                            <div class="col-md-4">
                                <label>Move Out Date</label>
                            </div>
                            <div class="col-md-8">
                                <mat-form-field class="datetime-field-class">
                                    <input matInput [(ngModel)]="moveOutDate" name="moveOutDate" placeholder="Choose a date"
                                           [matDatepicker]="moveOutDatePicker" (focus)="moveOutDatePicker.open()"
                                           (click)="moveOutDatePicker.open()" required [min]="currentDate">
                                    <mat-datepicker-toggle matSuffix [for]="moveOutDatePicker"></mat-datepicker-toggle>
                                    <mat-datepicker #moveOutDatePicker></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row m-b-sm" *ngIf="residentsList.length > 0">
                            <div class="col-md-4">
                                <label>Residents</label>
                            </div>
                            <ul class="col-md-8 pull-right list-unstyled">
                                <li *ngFor="let resident of residentsList; let index = index;" class="item-resident">
                                    <label class="img-checkbox">
                                        <input type="checkbox" [(ngModel)]="resident.checked"
                                               name="resident{{index}}" id="resident{{index}}">
                                        <label for="resident{{index}}">
                                            <svg-checked></svg-checked>
                                        </label>
                                    </label>
                                    <span class="resident-name long-text-hidden">{{resident.fullName}}</span>
                                    <role-field name="resident{{index}}-role" [noEdit]="true" [ngModel]="resident.suiteUser[0].role"></role-field>
                                </li>
                            </ul>
                        </div>
                        <div class="row m-b-sm" *ngIf="vehiclesList.length > 0">
                            <div class="col-md-4">
                                <label>Vehicles</label>
                            </div>
                            <div class="col-md-8 pull-right" *ngFor="let vehicle of vehiclesList; let index = index;">
                                <label class="img-checkbox">
                                    <input type="checkbox" [(ngModel)]="vehicle.checked"
                                           name="residentVehicle{{index}}" id="residentVehicle{{index}}">
                                    <label for="residentVehicle{{index}}">
                                        <svg-checked></svg-checked>
                                    </label>
                                </label>
                                {{vehicle.color}} {{vehicle.brand}} {{vehicle.model}} {{vehicle.licensePlate}}
                            </div>
                        </div>
                        <div class="row m-b-sm" *ngIf="petsList.length > 0">
                            <div class="col-md-4">
                                <label>Pets</label>
                            </div>
                            <div class="col-md-8 pull-right" *ngFor="let pet of petsList; let index = index;">
                                <label class="img-checkbox">
                                    <input type="checkbox" [(ngModel)]="pet.checked"
                                           name="residentPet{{index}}" id="residentPet{{index}}">
                                    <label for="residentPet{{index}}">
                                        <svg-checked></svg-checked>
                                    </label>
                                </label>
                                {{pet.name}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <label class="img-checkbox">
                                    <input type="checkbox" [(ngModel)]="moveInTo" name="moveInTo" id="moveInTo">
                                    <label for="moveInTo">
                                        <svg-checked></svg-checked>
                                    </label>
                                </label>
                                Move In To
                            </div>
                        </div>

                        <!-- ___ Building ___ -->
                        <div class="row m-b-sm" [hidden]="!moveInTo" [class.hidden]="buildings.length < 2">
                            <div class="col-md-4">
                                <label>Building</label>
                            </div>
                            <div class="col-md-8 fourteenPixelText">
                                <select class="form-control" name="moveInToBuildingId" [(ngModel)]="moveInToBuildingId"
                                        style="height: 28px;padding: 0 12px;" required
                                        (change)="changeBuilding($event.target.value)" #buildingSelect
                                        [disabled]="buildings.length === 0 || buildingSelectIsDisabled">
                                    <option value="" hidden></option>
                                    <option *ngFor="let build of buildings" [value]="build.id">{{build.name}}</option>
                                </select>
                                <spinner [spinnerShow]="buildings.length === 0"></spinner>
                            </div>
                        </div>

                        <!-- ___ Unit ___ -->
                        <div class="row m-b-sm" [hidden]="!moveInTo">
                            <div class="col-md-4">
                                <label>Unit</label>
                            </div>
                            <div class="col-md-8">
                                <search-select [(ngModel)]="moveInToSuiteId" name="moveInToSuiteId" required
                                               #suiteSelect [data]="suiteToSearchSelect(suites)"></search-select>
                                <input *ngIf="suiteSelect.value == '0'" class="form-control"
                                       [ngModel]="data.suiteNumber" name="otherSuite"
                                       placeholder="Other Unit Number" maxlength="255" required>
                                <spinner [spinnerShow]="buildingSelect.value &&
                                                    buildingSelect.value != 'null' &&
                                                    !suites.length"></spinner>
                            </div>
                        </div>

                        <div class="row text-center m-t-md">
                            <button class="btn btn-primary submit-btn" [disabled]="disabledSubmit">{{moveInTo ? 'Move' : 'Remove'}}</button>
                        </div>
                    </div>
                    <spinner [spinnerShow]="(!residentsList.length && !vehiclesList.length && !petsList.length) || showSpinner"></spinner>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal(form)"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/directory/move-out-modal/move-out-modal.component.html